module.exports = __webpack_public_path__ + "static/media/priceBlob.ac559fb1.svg";